import React, { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import { widState } from "../Store/workdriveState";

const ZOHO = window.ZOHO;

function useCrmVariable({ Entity = "", EntityId = "", crmVariableName = "" }) {
  const snap = useSnapshot(widState);
  const [crmVariable, setCrmVariable] = useState(null);
  // FIXME Comment out the below reurn code and send data from zoho crm variable
  return {
    orgid: widState.orgId,
    connname: "easydropboxforcrm",
    apikey: widState.apiKey,
    zuid: widState.zuid,
    zapikey: widState?.zapikey,
    datacenterurl: widState.dataCenterUrl,
  };
  return crmVariable;
}

export default useCrmVariable;
